import React from "react";

const index = props => (
  <div className="vibo-container">
    <div className="container">{props.children}</div>
  </div>
);

export default index;



// WEBPACK FOOTER //
// ./components/Section/index.js